/**
 *  Created by panwei on 2018/11/29 3:46 PM.
 */
!(function(c, i, e, b) {
  var h = i.createElement('script')
  var f = i.getElementsByTagName('script')[0]
  h.type = 'text/javascript'
  h.crossorigin = true

  const fnAddEvent = c.addEventListener
  const fnAttachEvent = c.attachEvent

  c.addEventListener = function(...args) {
    if (args[0] === 'error' || args[0] === 'unhandledrejection') {
      return
    }
    fnAddEvent.apply(this, args)
  }
  c.attachEvent = function(...args) {
    if (args[0] === 'onerror') {
      return
    }
    fnAttachEvent.apply(this, args)
  }

  h.onload = function() {
    // c[b] || (c[b] = new c.wpkReporter({ bid: 'dta_2_2297' }))
    // c[b].installAll()
    if (!c[b] && c.wpkReporter) {
      c[b] = new c.wpkReporter({ bid: 'dta_2_2297' })
      c[b].installAll()
    }

    c.addEventListener = fnAddEvent
    c.attachEvent = fnAttachEvent
    c.onerror = function() {}
  }
  f.parentNode.insertBefore(h, f)
  h.src = e
})(window, document, 'https://g.alicdn.com/woodpeckerx/jssdk??wpkReporter.js', '__wpk')
